import styled from 'styled-components'

import { Help } from '@syconium/little-miss-figgy'

import { NextLink } from '../../../app/_components/navigation/NextLink'
import { headerHeight } from '../../../brunswick/constants'
import {
  modalAnimationDuration,
  navModalPortalClassName,
} from '../../../brunswick/styles/constants'
import { Body as NavAccordion } from '../NavAccordion/styles'
import { Body as NavListSection } from '../NavListSection/styles'
import { navPushedBackCss, navPushedBackTransition } from '../NavSubMenuDialog'
import {
  Body as NavTileSection,
  ScrollWrap as NavTileSectionScrollWrap,
} from '../NavTileSection/styles'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-y: scroll;

  ${navPushedBackCss};

  .${navModalPortalClassName} .ReactModal__Content && {
    transition:
      background-color ${modalAnimationDuration}ms ease,
      ${navPushedBackTransition};

    @media (prefers-reduced-motion: reduce) {
      transition: background-color ${modalAnimationDuration}ms ease;
    }
  }
`

export const Top = styled.div`
  flex: 0 0;
`

// position is a style attribute for e2e testing
export const Header = styled.header`
  height: ${headerHeight};
  top: 0;
  z-index: ${o => o.theme.zIndex.foregroundContent};
  display: flex;
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
`

export const CloseButton = styled.button.attrs({ className: 'nav-modal-slides-in-from-right' })`
  padding: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;

  > svg {
    display: block;
  }
`

export const TabList = styled.div.attrs({ className: 'nav-modal-slides-in-from-right' })`
  background: white;

  height: 100%;
  width: 100%;
  padding-right: ${o => o.theme.spacing(4)};
`

export const Tab = styled.button<{
  isActive: boolean
  textColor?: string | null
}>`
  border-bottom: 5px solid
    ${o => (o.isActive ? o.textColor || o.theme.color.deprecated.obsidian : 'transparent')};
  border-top: 5px solid transparent;
  color: ${o =>
    o.textColor ||
    (o.isActive ? o.theme.color.deprecated.obsidian : o.theme.color.deprecated.obsidianLighter)};
  font-size: 16px;
  font-weight: bold;
  height: 100%;
  padding: 0 16px;
  user-select: none;

  &:hover {
    outline: none;
  }
`

export const TabPanel = styled.nav.attrs({ className: 'nav-modal-slides-in-from-right' })`
  background: white;

  > * {
    border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  }

  > :first-child,
  > ${NavAccordion} {
    border-top: none;
  }

  > ${NavListSection} {
    padding: 32px ${o => o.theme.dimensions.layout.sidePadding.md}px;
  }

  > ${NavTileSection} > ${NavTileSectionScrollWrap} {
    padding: 20px 12px;
  }
`

// Bottom is 2 equal halves. Could use Divider and justify: space-between.
export const Bottom = styled.div.attrs({ className: 'nav-modal-slides-in-from-right' })`
  background: white;
  border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  display: flex;
  flex-direction: column;
  flex: 0 0 50px;

  > section {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    min-height: 50px;
    padding: 0 8px;
    width: 100%;
  }
`

export const HelpLink = styled(NextLink)`
  font-size: 13px;
  font-weight: bold;
`

export const HelpIcon = styled(Help)`
  margin-inline-end: 10px;
  vertical-align: middle;
`

export const Middle = styled.div.attrs({ className: 'nav-modal-slides-in-from-right' })`
  background: white;
  flex: auto;
`
